var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTkn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 50,
    viewBox: "0 0 90 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0C1.20172e-06 27.2868 22.7845 49.9012 50.2766 49.9012C50.2766 22.6144 27.492 -1.19274e-06 0 0Z",
    fill: "#63B4AB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M90 14.0316C90 33.8964 73.7753 50 53.7611 50H50.3761C50.3761 30.1352 66.6008 14.0316 86.6151 14.0316H90Z",
    fill: "#63B4AB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.64843 8.49804C7.64843 31.3736 26.3323 49.918 49.3799 49.918C49.3799 27.0424 30.6961 8.49804 7.64843 8.49804Z",
    fill: "#439C92"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M82.352 20.1448C82.352 36.6333 68.8848 49.9999 52.2722 49.9999H49.4626C49.4626 33.5114 62.9297 20.1448 79.5423 20.1448H82.352Z",
    fill: "#439C92"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTkn);
export default __webpack_public_path__ + "static/media/TKN.04cc5ce5cbfa86743ac54d0251f4485b.svg";
export { ForwardRef as ReactComponent };